<template>
    <span :class="clz">{{ text }}</span>
</template>

<script>
export default {
    props: {
        class: {
            type: String,
            default: () => ''
        },
        // 类型编码
        typeCode: String,
        // 默认值
        dictValue: [String, Number]
    },
    data() {
        return {
            list: [],
            clz: `com-dict-text-${this.class}`
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 查询字典列表
        getList() {
            // 不刷新的情况下只请求一次
            if (!window._dictionary) {
                window._dictionary = {}
            }
            if (window._dictionary[this.typeCode]) {
                this.list = window._dictionary[this.typeCode]
            } else {
                this.$baseApi.getDictData({
                    dictType: this.typeCode
                }).then(res => {
                    if (res.success) {
                        this.list = res.data.list
                        window._dictionary[this.typeCode] = res.data.list
                    }
                })
            }
        }
    },
    computed: {
        // 显示选中值文本内容
        text () {
            const item = this.list.find(v => {
                return v.dictValue == this.dictValue
            })
            return item?.dictLabel || '-'
        }
    }
}
</script>